import {StrictMode} from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';
import App, {loadInitialRoutePage} from './App.tsx';
import './index.css';

async function startApp() {
  const root = document.getElementById('root')!;
  const hasPrerenderedContent = root.hasChildNodes();
  const initialRoutePage = hasPrerenderedContent ? await loadInitialRoutePage(window.location.pathname) : undefined;
  const app = (
    <StrictMode>
      <App initialRoutePage={initialRoutePage} />
    </StrictMode>
  );

  if (hasPrerenderedContent) {
    hydrateRoot(root, app);
  } else {
    createRoot(root).render(app);
  }
}

void startApp();
